var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_437_52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.3828 0 0 5.38331 0 12C0 18.6167 5.3828 24 12 24C18.6172 24 24 18.6167 24 12C24 5.38331 18.6172 0 12 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7705 12.4205L9.77053 16.9205C9.6885 16.9738 9.59377 17.0001 9.50002 17.0001C9.41798 17.0001 9.33497 16.9796 9.26077 16.9391C9.09961 16.8512 9 16.6832 9 16.5001V7.50013C9 7.31703 9.09961 7.14903 9.26077 7.06114C9.41897 6.97424 9.6172 6.97958 9.77053 7.0797L16.7705 11.5797C16.9131 11.6715 17 11.8302 17 12.0001C17 12.17 16.9131 12.3287 16.7705 12.4205Z",
    fill: "#ff5a3c"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_437_52"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayRed);
export default __webpack_public_path__ + "static/media/play-red.a9899b6074cd9a9fe4c9d386360c4d94.svg";
export { ForwardRef as ReactComponent };